import CountryPageRenderer from '../components/CountryPageRenderer';
import philippinesData from '../data/country-pages/philippines';

export default function PhilippinesCountryPage() {
  return <CountryPageRenderer data={philippinesData} />;
}
